import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: null,
  currentPage: 1,
  totalPages: 1,
};

const filterList = (list, key, value) => {
  return list.filter((client) => {
    return !client.hasOwnProperty(key) || client[key] !== value;
  });
};

export const clientSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    setList: (state, action) => {
      state.list = action.payload;
    },
    setAll: (state, action) => {
      state.all = action.payload;
    },
    appendToList: (state, action) => {
      state.list.push(action.payload);
    },
    removeFromListByIndex: (state, action) => {
      state.list.splice(action.payload, 1);
    },
    removeFromListById: (state, action) => {
      state.list = filterList(state.list, "id", action.payload);
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
  },
});

export const {
  setList,
  setAll,
  appendToList,
  removeFromListByIndex,
  removeFromListById,
  setCurrentPage,
  setTotalPages,
} = clientSlice.actions;

export default clientSlice.reducer;
